import rewardEn from './reward/en.json';
import rewardZhHant from './reward/zh-Hant.json';
import rewardTh from './reward/th.json';
import rewardVi from './reward/vi.json';

export default {
  en: rewardEn,
  'zh-Hant': rewardZhHant,
  th: rewardTh,
  vi: rewardVi,
};
